import { Instant } from "@js-joda/core";
import { useGetRecentData } from "api/api-hooks/datasets-hooks";
import { DATE_PATTERN_SECONDS } from "utils/constants";
import { DweenTimeUnitEnum } from "utils/enums";
import { useDisplayTimezone } from "hooks/useTimezone";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { T } from "services/lang/LanguageService";
import { addToInstant, fmtDatetime } from "utils/time-utils";
import { ILastKnownValueTimeMomentProps } from "./LastKnownValueTimeMomentTypes";

export default function LastKnownValueTimeMoment(props: ILastKnownValueTimeMomentProps) {
  const displayTz = useDisplayTimezone();
  const [instant, setInstant] = useState<Instant | undefined>();

  const dateFormat = props.dateFormat || DATE_PATTERN_SECONDS;
  const text = props.customText || "";

  const { data, isLoading } = useGetRecentData([props.identifier], {
    options: {
      refetchInterval: props.updateFrequency ? props.updateFrequency * 1000 : 5000,
    },
  });

  useEffect(() => {
    if (data && data[0]?.data[0]?.key) {
      const lastValueTime = data[0]?.data[0]?.key;
      const lastValueTimeInstant = Instant.parse(lastValueTime);
      const offsetInstant = addToInstant(
        lastValueTimeInstant,
        props.delta?.value || 0,
        props.delta?.unit ?? DweenTimeUnitEnum.DAYS,
        displayTz
      );
      setInstant(offsetInstant);
    } else {
      setInstant(undefined);
    }
  }, [data, props.delta?.unit, props.delta?.value]);

  if (isLoading) {
    return <ProgressSpinner />;
  }

  if (!instant) {
    return <div>{T("message.this-dataset-has-no-values")}</div>;
  }

  return (
    <div className="last-value-time-indicator" style={props.style as React.CSSProperties}>
      {text.length > 0 ? `${text}: ` : ""}
      {fmtDatetime(instant, displayTz, dateFormat)}
    </div>
  );
}
